const generateVehicleParams = modifiers => {
  let params = ''
  if (modifiers && modifiers.vehicle) {
    Object.keys(modifiers.vehicle.details).forEach(key => {
      const value = modifiers.vehicle.details[`${key}`]
      if (!value || value === '') return
      if (key === 'engine' && value !== '') {
        const [cylinder, liter] = value.split(' Cyl ')
        params += `&vehicle[cylinders]=${encodeURIComponent(cylinder)}`
        params += `&vehicle[liter]=${encodeURIComponent(liter.replace('L', ''))}`
        return
      }

      params += `&vehicle[${key}]=${encodeURIComponent(value)}`
    })
  }

  return params
}

export default generateVehicleParams
